// Generated by purs version 0.14.4
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var Leibniz = function (x) {
    return x;
};
var unDistinguished = function (dictDistinguish) {
    return Unsafe_Coerce.unsafeCoerce;
};
var trans = function (v) {
    return function (v1) {
        return function ($30) {
            return v1(v($30));
        };
    };
};
var symm = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var semigroupoidLeibniz = {
    compose: Data_Function.flip(trans)
};
var runLeibniz = function (v) {
    return v;
};
var refl = Control_Category.identity(Control_Category.categoryFn);
var lowerLeibniz3of3 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz2of3 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz2of2 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz1of3 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz1of2 = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var lowerLeibniz = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var distinguished = function (dictDistinguish) {
    return Unsafe_Coerce.unsafeCoerce;
};
var distinguishRight = {};
var distinguishLeft = {};
var refute = function (dictDistinguish) {
    return function (l) {
        return Data_Void.absurd(unDistinguished()(runLeibniz(l)(distinguished()(Data_Unit.unit))));
    };
};
var coerceSymm = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var coerce = function (v) {
    return Unsafe_Coerce.unsafeCoerce;
};
var categoryLeibniz = {
    identity: refl,
    Semigroupoid0: function () {
        return semigroupoidLeibniz;
    }
};
var applyLeibniz3of3 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz3of3 = applyLeibniz3of3(Control_Category.identity(categoryLeibniz));
var applyLeibniz2of3 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz2of3 = applyLeibniz2of3(Control_Category.identity(categoryLeibniz));
var applyLeibniz2of2 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz2of2 = applyLeibniz2of2(Control_Category.identity(categoryLeibniz));
var applyLeibniz1of3 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz1of3 = applyLeibniz1of3(Control_Category.identity(categoryLeibniz));
var applyLeibniz1of2 = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz1of2 = applyLeibniz1of2(Control_Category.identity(categoryLeibniz));
var applyLeibniz = function (v) {
    return function (v1) {
        return Unsafe_Coerce.unsafeCoerce;
    };
};
var liftLeibniz = applyLeibniz(Control_Category.identity(categoryLeibniz));
export {
    Leibniz,
    runLeibniz,
    coerce,
    coerceSymm,
    symm,
    liftLeibniz,
    liftLeibniz1of2,
    liftLeibniz2of2,
    liftLeibniz1of3,
    liftLeibniz2of3,
    liftLeibniz3of3,
    applyLeibniz,
    applyLeibniz1of2,
    applyLeibniz2of2,
    applyLeibniz1of3,
    applyLeibniz2of3,
    applyLeibniz3of3,
    lowerLeibniz,
    lowerLeibniz1of2,
    lowerLeibniz2of2,
    lowerLeibniz1of3,
    lowerLeibniz2of3,
    lowerLeibniz3of3,
    refute,
    semigroupoidLeibniz,
    categoryLeibniz,
    distinguishLeft,
    distinguishRight
};
//# sourceMappingURL=index.js.map
